import React from "react";

export const Bottom3 = ({ color }) => {
  return (
    <>
      <svg
        width="128"
        height="123"
        viewBox="0 0 128 123"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="63.8953"
          cy="59.2742"
          r="55.9432"
          stroke={color}
          strokeWidth="0.66205"
        />
        <circle
          cx="63.8939"
          cy="59.2738"
          r="6.28947"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M63.8945 51.9917V3.66211"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M63.8945 114.225V65.8955"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M70.85 58.9443L119.18 58.9443"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M8.61177 58.9443L56.9414 58.9443"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M68.8063 63.858L102.98 98.0322"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M24.7984 19.8541L58.9727 54.0283"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M58.975 63.858L24.8008 98.0322"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M102.983 19.8512L68.8086 54.0254"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M58.975 63.858L24.8008 98.0322"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M102.983 19.8512L68.8086 54.0254"
          stroke={color}
          strokeWidth="0.66205"
        />
        <path
          d="M27.813 95.6865L1 122.5H126.789L99.9765 95.6865"
          stroke={color}
          strokeWidth="0.66205"
        />
        <rect x="20" y="17" width="9" height="9" fill={color} />
        <rect x="20" y="96" width="9" height="9" fill={color} />
        <rect x="99" y="17" width="9" height="9" fill={color} />
        <rect x="99" y="96" width="9" height="9" fill={color} />
        <rect x="4" y="54" width="9" height="9" fill={color} />
        <rect x="115" y="54" width="9" height="9" fill={color} />
        <rect x="59" width="9" height="9" fill={color} />
        <rect x="59" y="110" width="9" height="9" fill={color} />
      </svg>
    </>
  );
};
